import { useQuery } from '@tanstack/react-query';
import { templateService } from '../services/templateService';

export function useTemplate() {
  return useQuery({
    queryKey: ['template'],
    queryFn: () => templateService.getTemplate(),
    staleTime: 5 * 60 * 1000, // 5 minutes
    retry: 1, // Only retry once
    retryDelay: 1000, // Wait 1 second before retrying
  });
}
